import { Order } from '~src/spacesPlatform/models/sort/Order';

import { OptionDefinition } from './SortOptionDefinitions';

export function createNonDisplayOptionDefinition(id: string, field: string): OptionDefinition {
  return {
    id: id,
    getMenuItemDisplayValue: () => '',
    subSortOptions: {
      'asc': {
        id: id + '.asc',
        field: field,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: true,
        toOrderClauseArray: () => [Order.asc(field)]
      },
      'desc': {
        id: id + '.desc',
        field: field,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: false,
        toOrderClauseArray: () => [Order.desc(field)]
      }
    }
  };
}
